import objectPath from 'object-path'
import cloneDeep from 'clone-deep'
import {
  goToForm,
  goToPage,
  goToUrl,
  goToModal,
  showAndHide,
  mapFieldTable,
  mapToData,
} from '../Action'
import { crud, crudCondition } from '../action/Crud'

const getStatusValue = (value) => {
  if (typeof value === 'number') {
    return value
  } else if (typeof value === 'string' && value !== '' && !isNaN(value)) {
    return Number(value)
  } else if (value === 'true') {
    return true
  } else if (value === 'false') {
    return false
  } else if (value === 'null') {
    return null
  } else if (value === 'undefined') {
    return undefined
  }
  return value
}

const getStatusRowData = (action, rowData) => {
  let { statusField, statusValue } = action
  let method = action.method || ''
  method = method.toLowerCase()
  let isSoftDelete =
    action.name === 'delete' &&
    (action.action === 'updateStatus' || method === 'put' || method === 'patch')
  if (!statusField && isSoftDelete && objectPath.has(rowData, 'isActive')) {
    statusField = 'isActive'
    statusValue = 0
  }
  if (!statusField) return rowData

  let newData = cloneDeep(rowData)
  objectPath.set(newData, statusField, getStatusValue(statusValue))
  return newData
}

export const createActionRouterHelper = ({
  jsonForm,
  formData,
  uischema,
  designContext,
  historyContext,
  renderTableData,
  allParams,
  user,
  setLoading,
  setModalAction,
  setRender,
  history,
  location,
  formatDate,
  formatTime,
  formatDateTime,
  callback,
  setComponentPropsData,
  setDataRowClicked,
  setFieldFormData,
  isUiChanged,
  setIsUiChanged,
  selectRow,
  createClickRow,
}) => {
  const onRowDefaultAction = (action, rowData = {}, isApi = false) => {
    switch (action.action) {
      case 'api':
        return crud({
          action,
          rowData: getStatusRowData(action, rowData),
          designContext,
          renderTableData,
          allParams,
          user,
          uischema,
        })
      case 'apiCondition':
        return crudCondition({
          action,
          rowData: getStatusRowData(action, rowData),
          designContext,
          renderTableData,
          allParams,
          user,
          uischema,
        })
      case 'updateStatus':
        return crud({
          action: {
            ...action,
            action: 'api',
            method: action.method || 'put',
          },
          rowData: getStatusRowData(action, rowData),
          designContext,
          renderTableData,
          allParams,
          user,
          uischema,
        })
      case 'goToForm':
        return goToForm(
          action,
          history,
          rowData,
          designContext,
          historyContext,
          { formatDate, formatTime, formatDateTime },
        )
      case 'goToPage':
        return goToPage(
          action,
          history,
          rowData,
          designContext,
          historyContext,
          uischema.key,
        )
      case 'goToUrl':
        return goToUrl(action, uischema, rowData, designContext, location)
      case 'openModal':
        setModalAction(action)
        return goToModal(
          action,
          objectPath.get(action, 'modal.key'),
          rowData,
          designContext,
          uischema,
        )
      case 'showAndHide':
        return showAndHide(action, designContext)
      case 'mapFieldTable':
        return mapFieldTable(action, rowData, designContext, setRender)
      default:
        return (
          isApi &&
          crud({
            action,
            rowData: getStatusRowData(action, rowData),
            designContext,
            renderTableData,
            allParams,
            user,
            uischema,
          })
        )
    }
  }

  const getAction = (rowData) => {
    switch (uischema.action.name) {
      case 'selectRow':
        return selectRow(uischema.action, rowData)
      case 'selectRowTable':
        if (uischema.action.selectType === 'onTab') {
          return selectRow(uischema.action, rowData)
        }
        return
      case 'goToForm':
        return goToForm(
          uischema.action,
          history,
          rowData,
          designContext,
          historyContext,
          { formatDate, formatTime, formatDateTime },
        )
      case 'goToPage':
        return goToPage(
          uischema.action,
          history,
          rowData,
          designContext,
          historyContext,
          uischema.key,
        )
      case 'goToUrl':
        return goToUrl(
          uischema.action,
          uischema,
          rowData,
          designContext,
          location,
        )
      case 'openModal':
        setModalAction(uischema.action)
        return goToModal(
          uischema.action,
          objectPath.get(uischema, 'action.modal.key'),
          rowData,
          designContext,
          uischema,
        )
      case 'showAndHide':
        return showAndHide(uischema.action, designContext)
      case 'callback':
        return callbackFunction(uischema.action, rowData, designContext)
      case 'mapFieldTable':
        return mapFieldTable(uischema.action, rowData, designContext, setRender)
      case 'mapToData':
        return mapToData(uischema, rowData, designContext, createClickRow)
      default:
        if (
          uischema.action.name === 'selectRowTable' &&
          uischema.action.selectType === 'onTab'
        ) {
          return selectRow(uischema.action, rowData)
        }
        return
    }
  }

  const getApiRowProps = () => ({
    jsonForm,
    formData,
    uischema,
    designContext,
    renderTableData,
    allParams,
    user,
    setLoading,
    onRowDefaultAction,
  })

  const callbackFunction = (action, rowData) => {
    let componentPropsData = {}
    let { callbackName } = action
    if (callbackName) {
      const onCallFunction = objectPath.get(callback, callbackName)
      if (onCallFunction) {
        const onSelectRow = objectPath.get(callback, '@onSelectRow')
        onSelectRow(rowData)
        objectPath.set(componentPropsData, 'isCallback', true)
        onCallFunction(rowData)
      } else {
        objectPath.set(componentPropsData, 'isCallback', false)
      }
    } else {
      objectPath.set(componentPropsData, 'isCallback', false)
    }
    objectPath.set(componentPropsData, 'isSelectedRow', true)
    objectPath.set(componentPropsData, 'rowData', rowData)
    setComponentPropsData(componentPropsData)
    setDataRowClicked(rowData)
    setFieldFormData(`@rowSelected.${uischema.key}`, rowData)
    objectPath.set(isUiChanged, uischema.key, { isRender: true })
    setIsUiChanged(isUiChanged)
  }

  return {
    onRowDefaultAction,
    getApiRowProps,
    getAction,
  }
}
